import type { LucideIcon } from "lucide-react";
import {
  BookOpen,
  CalendarClock,
  Home,
  LayoutGrid,
  MessageSquareText,
  Sparkles
} from "lucide-react";

export type NavItem = {
  label: string;
  to: string;
  icon: LucideIcon;
  description?: string;
  externalUrl?: string;
};

export const NAV_ITEMS: NavItem[] = [
  {
    label: "홈",
    to: "/",
    icon: Home,
    description: "전체 도구를 한눈에"
  },
  {
    label: "워크메이트",
    to: "/workmate",
    icon: LayoutGrid,
    description: "업무 자동화 · 문서 · 평가"
  },
  {
    label: "클래스메이트",
    to: "/classmate",
    icon: Sparkles,
    description: "수업 준비 · 학급 운영"
  },
  {
    label: "인포메이트",
    to: "/informate",
    icon: LayoutGrid,
    description: "자료/정보 모음 · 링크"
  },
  {
    label: "시간표",
    to: "/timetable/schools",
    icon: CalendarClock,
    description: "시간표 자동 생성 · 관리"
  },
  {
    label: "소통공간",
    to: "/community",
    icon: MessageSquareText,
    description: "게시판 · 공유 · Q&A"
  },
  {
    label: "이용가이드",
    to: "/guide",
    icon: BookOpen,
    description: "사이트 전체 사용법"
  }
];





